module.exports = __webpack_public_path__ + "img/paint-brush-fine.25122b2a.svg";